var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62618 6.59476C1.62618 7.16963 1.75236 7.61099 1.91728 7.87801C2.13351 8.22775 2.45602 8.37592 2.78482 8.37592C3.2089 8.37592 3.59686 8.27068 4.3445 7.23665C4.94346 6.40785 5.64921 5.2445 6.12408 4.51518L6.92827 3.27958C7.48691 2.42147 8.13351 1.46754 8.87487 0.820942C9.4801 0.293194 10.133 0 10.7901 0C11.8932 0 12.944 0.639267 13.7482 1.83822C14.6283 3.15131 15.0555 4.80524 15.0555 6.51204C15.0555 7.5267 14.8555 8.27225 14.5152 8.86126C14.1864 9.43089 13.5455 10 12.4675 10V8.37592C13.3906 8.37592 13.6209 7.52775 13.6209 6.55707C13.6209 5.17382 13.2984 3.63874 12.588 2.54188C12.0838 1.76387 11.4304 1.28848 10.7115 1.28848C9.93403 1.28848 9.30838 1.87487 8.60524 2.92042C8.23141 3.47592 7.84764 4.15288 7.41675 4.91675L6.94241 5.75707C5.98953 7.4466 5.74817 7.83141 5.27173 8.46649C4.43665 9.57853 3.72356 10 2.78482 10C1.6712 10 0.967016 9.5178 0.53089 8.7911C0.174869 8.19895 0 7.42199 0 6.53665L1.62618 6.59476Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28223 1.95288C2.02778 0.803665 3.10369 0 4.33772 0C5.05238 0 5.76285 0.211518 6.50474 0.817277C7.31626 1.47958 8.18118 2.57016 9.26024 4.36754L9.64715 5.01257C10.5812 6.56859 11.1126 7.36911 11.4236 7.7466C11.8236 8.23141 12.1037 8.37592 12.4676 8.37592C13.3906 8.37592 13.621 7.52775 13.621 6.55707L15.0555 6.51204C15.0555 7.5267 14.8555 8.27225 14.5152 8.86126C14.1864 9.43089 13.5456 10 12.4676 10C11.7974 10 11.2037 9.85445 10.5471 9.23508C10.0424 8.75969 9.45238 7.91518 8.99846 7.15602L7.6482 4.90052C6.97071 3.76859 6.34924 2.92461 5.98956 2.54241C5.60265 2.13141 5.10526 1.63508 4.31155 1.63508C3.66914 1.63508 3.12359 2.08586 2.66704 2.77539L1.28223 1.95288Z",
    fill: "url(#paint0_linear_753_4512)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31152 1.63508C3.66911 1.63508 3.12356 2.08586 2.66702 2.77539C2.02147 3.74974 1.62618 5.20105 1.62618 6.59476C1.62618 7.16963 1.75236 7.61099 1.91728 7.87801L0.53089 8.7911C0.174869 8.19895 0 7.42199 0 6.53665C0 4.9267 0.441885 3.24869 1.2822 1.95288C2.02775 0.803665 3.10366 0 4.3377 0L4.31152 1.63508Z",
    fill: "url(#paint1_linear_753_4512)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_753_4512",
    x1: 3.19374,
    y1: 6.12565,
    x2: 13.5602,
    y2: 6.64921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_753_4512",
    x1: 2.35602,
    y1: 7.27749,
    x2: 2.35602,
    y2: 3.4555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteIcon);
export default __webpack_public_path__ + "static/media/mete-icon.eca629fd2a313a60feb19d10b516db0f.svg";
export { ForwardRef as ReactComponent };